/* ============
 * Default Layout
 * ============
 *
 * Used for the home and account pages
 *
 * Layouts are used to store a lot of shared code.
 * This way the app stays clean.
 */

import authService from '@/services/auth';
import EventBus from '@/utils/eventBus';

export default {
  data() {
    return {
      collapsed: false,
      loading: false,
    };
  },
  mounted() {
    EventBus.$on('show-loading', (isShow) => {
      this.loading = isShow;
    });
  },
  methods: {
    logout() {
      authService.logout();
    },
  },
  components: {
    VSidebar: require('@/components/sidebar/sidebar.vue'),
    VNavbar: require('@/components/navbar/navbar.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/layouts/default/default.js